<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('bill.supplement_bill')}}</div>
    <div slot="body">
      <a-form class="mt-3" :form="form.fc" v-bind="formItemLayout">
        <a-form-item :label="$t('cloudenv.text_212')">
          <span slot="extra" style="color:red" v-if="blockTip">{{ blockTip }}</span>
          <a-form-item style="display:inline-block">
            <a-month-picker :disabled-date="dateDisabledStart" v-decorator="decorators.start_day" @change="startChange" />
          </a-form-item>
          <span class="ml-2 mr-2">~</span>
          <a-form-item style="display:inline-block">
            <a-month-picker :disabled-date="dateDisabledEnd" v-decorator="decorators.end_day" />
          </a-form-item>
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading" :disabled="!!blockTip">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'BlockAccountCreateDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      form: {
        fc: this.$form.createForm(this, {
          onValuesChange: (props, values) => {
            Object.keys(values).forEach((key) => {
              this.form.fd[key] = values[key]
            })
          },
        }),
        fd: {
          start_day: this.$moment().startOf('month').subtract('month', 1),
          end_day: this.$moment().subtract('month', 1),
        },
      },
      decorators: {
        start_day: ['start_day', {
          initialValue: this.$moment().startOf('month').subtract('month', 1),
          rules: [{ required: true, message: this.$t('common.tips.select', [this.$t('bill.text_40')]) }],
        }],
        end_day: ['end_day', {
          initialValue: this.$moment().subtract('month', 1),
          rules: [{ required: true, message: this.$t('common.tips.select', [this.$t('bill.text_41')]) }],
        }],
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      blockMonths: [],
    }
  },
  computed: {
    start () {
      return this.$moment(this.form.fd.start_day).format('YYYY-MM')
    },
    end () {
      return this.$moment(this.form.fd.end_day).format('YYYY-MM')
    },
    selectedMonths () {
      const list = []
      const start = this.$moment(this.start)
      const end = this.$moment(this.end)
      // eslint-disable-next-line
      while (end > start || start.format('M') === end.format('M')) {
        list.push(start.format('YYYYMM'))
        start.add(1, 'month')
      }
      return list
    },
    blockTip () {
      const blockMonths = []
      this.selectedMonths.map(month => {
        if (this.blockMonths.includes(month)) {
          blockMonths.push(`${month.slice(0, 4)}-${month.slice(4, 6)}`)
        }
      })
      return blockMonths.length ? this.$t('bill.block_account_create_tip', [blockMonths.join('、')]) : ''
    },
  },
  watch: {
    start: {
      handler (val) {
        this.fetchBlockAccount()
      },
    },
    end: {
      handler (val) {
        this.fetchBlockAccount()
      },
    },
  },
  created () {
    this.fetchBlockAccount()
  },
  methods: {
    fetchBlockAccount () {
      new this.$Manager('blocking_accounts', 'v1').list({
        params: {
          account_id: this.params.account_id,
          filter: `month.in(${this.selectedMonths.join(',')})`,
        },
      }).then(res => {
        const { data = [] } = res.data
        this.blockMonths = data.map(item => `${item.month}`)
      })
    },
    startChange (value) {
      const dateEnd = this.form.fc.getFieldValue('end_day')
      if (dateEnd && value > dateEnd) {
        this.form.fc.setFieldsValue({
          end_day: value,
        })
      }
    },
    dateDisabledStart (value) {
      // const dateEnd = this.form.fc.getFieldValue('end_day')
      // if (dateEnd && value > dateEnd) return true
      if (value > this.$moment()) return true
      return false
    },
    dateDisabledEnd (value) {
      const dateStart = this.form.fc.getFieldValue('start_day')
      if (dateStart && value < dateStart) return true
      if (value > this.$moment()) return true
      return false
    },
    async handleConfirm () {
      try {
        this.loading = false
        await this.form.fc.validateFields()
        for (let i = 0; i < this.selectedMonths.length; i++) {
          await this.params.onManager('create', {
            managerArgs: {
              data: {
                account_id: this.params.account_id,
                month: parseInt(this.selectedMonths[i]),
              },
            },
          })
        }
        this.loading = false
        this.cancelDialog()
      } catch (err) {
        this.loading = false
        throw err
      }
    },
  },
}
</script>
